/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Meta_DescriptionInputs */

const ja_playdata_about_meta_description = /** @type {(inputs: Playdata_About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）は、eスポーツ関連の大会・イベントの配信データを分析・レポート化し、皆様のマーケティング活動に活用して頂けるウェブサービスです。`)
};

const en_playdata_about_meta_description = /** @type {(inputs: Playdata_About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA analyses and reports distribution and viewership data for Japanese esports competitions and events.`)
};

/**
* | output |
* | --- |
* | "PLAYDATA analyses and reports distribution and viewership data for Japanese esports competitions and events." |
*
* @param {Playdata_About_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_meta_description = /** @type {((inputs?: Playdata_About_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_meta_description(inputs)
	return en_playdata_about_meta_description(inputs)
});